import React from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Divider
} from '@mui/material';
import { StatusBadge } from '../common';
import { Resource } from '../../types';

interface ResourceDetailsCardProps {
  resource: Resource;
  elevation?: number;
  padding?: number;
}

/**
 * A reusable component for displaying resource details
 */
const ResourceDetailsCard: React.FC<ResourceDetailsCardProps> = ({ 
  resource, 
  elevation = 1,
  padding = 2
}) => {
  return (
    <Paper elevation={elevation} sx={{ p: padding }}>
      <Typography variant="h6" gutterBottom>Resource Information</Typography>
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Resource Name</Typography>
        <Typography variant="body1">{resource.name}</Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Category</Typography>
        <Typography variant="body1">{resource.category}</Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Description</Typography>
        <Typography variant="body1">{resource.description || 'No description available'}</Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Status</Typography>
        <StatusBadge status={resource.isActive ? 'active' : 'inactive'} />
      </Box>
      <Box mb={2}>
        <Typography variant="body2" color="text.secondary">Quantity</Typography>
        <Typography variant="body1">{resource.quantity}</Typography>
      </Box>
    </Paper>
  );
};

export default ResourceDetailsCard;
